import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

//Styles
import "./App.scss";

//Pages
import PageLanding from "./pages/Landing/PageLanding";
import PageNotFound from "./pages/NotFound/PageNotFound";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <PageLanding />
        </Route>
        <Route path="*">
          <PageNotFound />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
